import { z } from 'zod';

export const GroupBalanceSchema = z.object({
  name: z.string().min(3).max(100),
  description: z.string().max(250).optional(),
  balances: z.array(z.number().int()),
});
